import React from 'react'
import { RunContextItem } from '../../../store/customWorkflow/customWorkflows'
import { primaryContextLabel } from './contextLabels'

export const RunContextChip: React.FC<{ context?: RunContextItem[] }> = ({ context }) => {
  const label = primaryContextLabel(context)
  if (!label) return null
  return <span className='paragraph-small zocks-text-gray-600'>{label}</span>
}
